import { render, staticRenderFns } from "./MoveOrCopyModal.vue?vue&type=template&id=23b35fc8&scoped=true"
import script from "./MoveOrCopyModal.vue?vue&type=script&lang=js"
export * from "./MoveOrCopyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b35fc8",
  null
  
)

export default component.exports